import { createSelector } from "@reduxjs/toolkit";

import { infoBlockItemsSelectorHelper } from "shared/state";
import { IInfoBlockItem, IPaginationItem } from "shared/types";
import { dataSelector } from "./helpers";

export const infoBlockItemsSelector = (props: {
  type: IInfoBlockItem;
  paths?: string[];
  itemIds?: string[];
}) => createSelector(dataSelector, data => infoBlockItemsSelectorHelper({ ...props, data }));

export const venueInfoBlockItemsSelector = (type: IInfoBlockItem, pagination: IPaginationItem) => {
  const paths = pagination.pages?.[pagination.currentPage] || [];

  return infoBlockItemsSelector({ type, paths });
};
